import React from "react";

export default function AssetInfoCard(
{
    title,
    fields = []
})
{
    const inputStyle =
    {
        width: "100%",
        padding: "8px 12px",
        borderRadius: "7px",
        border: "1px solid #d9e1eb",
        background: "#ffffff",
        fontSize: "13px",
        outline: "none",
        boxSizing: "border-box"
    };

    const labelStyle =
    {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        fontSize: "10px",
        fontWeight: "bold",
        color: "#777",
        textTransform: "uppercase",
        letterSpacing: "1px",
        marginBottom: "4px"
    };

    function renderField(field, index)
    {
        switch(field.type)
        {
            case "select":

                return (

                    <select
                        key={index}
                        style={inputStyle}
                        defaultValue={field.value || ""}
                    >
                        {(field.options || []).map(function(option)
                        {
                            return (
                                <option
                                    key={option}
                                    value={option}
                                >
                                    {option}
                                </option>
                            );
                        })}
                    </select>

                );

            case "textarea":

                return (

                    <textarea
                        key={index}
                        style={{
                            ...inputStyle,
                            resize: "vertical",
                            minHeight: "90px"
                        }}
                        defaultValue={field.value}
                    />

                );

            case "checkbox":

                return (

                    <label
                        key={index}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            fontSize: "13px",
                            color: "#444",
                            cursor: "pointer"
                        }}
                    >

                        <input
                            type="checkbox"
                            defaultChecked={field.value}
                            style={{
                                transform: "scale(1.15)"
                            }}
                        />

                        {field.checkboxLabel || field.label}

                    </label>

                );

            default:

                return (

                    <input
                        key={index}
                        type={field.type || "text"}
                        style={inputStyle}
                        defaultValue={field.value}
                        placeholder={field.placeholder || ""}
                    />

                );
        }
    }

    return (

        <div
            style={{
                width: "520px",
                background: "#f7f9fc",
                borderRadius: "14px",
                border: "1px solid #e3e9f0",
                boxShadow: "0 10px 24px rgba(0,0,0,.08)",
                overflow: "hidden",
                marginBottom: "16px",
                transition: "all .25s ease"
            }}
        >

            {/* ===================================================== */}
            {/* Header                                                */}
            {/* ===================================================== */}

            <div
                style={{
                    background:"#f2f5f8",
                    borderBottom: "1px solid #e5ebf2",
                    padding: "16px 22px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }}
            >

                <div
                    style={{
                        fontSize: "20px",
                        fontWeight: "bold",
                        color: "#333"
                    }}
                >
                    {title}
                </div>

               

            </div>

            {/* ===================================================== */}
            {/* Body                                                  */}
            {/* ===================================================== */}

            <div
                style={{
                    padding: "18px"
                }}
            >

                {
                    fields.map(function(field, index)
                    {
                        return (

                            <div
                                key={index}
                                style={{
                                    marginBottom: "14px"
                                }}
                            >

                                {
                                    field.type !== "checkbox" &&

                                    <div style={labelStyle}>

                                        <span>
                                            {field.label}

                                            {
                                                field.required &&
                                                <span
                                                    style={{
                                                        color: "#d32f2f",
                                                        marginLeft: "4px"
                                                    }}
                                                >
                                                    *
                                                </span>
                                            }

                                        </span>

                                        {
                                            field.ai &&
                                            <span
                                                style={{
                                                    color: "#5a9bd6",
                                                    fontSize: "12px"
                                                }}
                                            >
                                                🤖
                                            </span>
                                        }

                                    </div>
                                }

                                {renderField(field, index)}

                            </div>

                        );
                    })
                }

            </div>

        </div>

    );
}